import {
  Baby,
  BookOpen,
  Briefcase,
  Building2,
  CalendarDays,
  Car,
  Dumbbell,
  GraduationCap,
  Heart,
  Hospital,
  House,
  Landmark,
  Music,
  Pill,
  Plane,
  Receipt,
  Star,
  Stethoscope,
  Users,
  UtensilsCrossed,
  Wallet,
  type LucideIcon,
} from 'lucide-react';
import type { IconId } from '@autoday/core';
import { iconLabel } from '../i18n/format.ts';

export const ICONS: Record<IconId, LucideIcon> = {
  home: House,
  briefcase: Briefcase,
  hospital: Hospital,
  stethoscope: Stethoscope,
  building: Building2,
  landmark: Landmark,
  receipt: Receipt,
  wallet: Wallet,
  dumbbell: Dumbbell,
  plane: Plane,
  car: Car,
  calendar: CalendarDays,
  star: Star,
  book: BookOpen,
  users: Users,
  utensils: UtensilsCrossed,
  pill: Pill,
  baby: Baby,
  graduation: GraduationCap,
  music: Music,
  heart: Heart,
};

export function ItemIcon({ icon, size = 16, label }: { icon: IconId; size?: number; label?: boolean }) {
  const C = ICONS[icon] ?? Star;
  return (
    <>
      <C size={size} aria-hidden strokeWidth={2} />
      {label && <span className="sr-only">{iconLabel(icon)}</span>}
    </>
  );
}
